import React from 'react';
import { MenuEntry } from '@europrocurement/flexy-components';

import { publisherIcon, publishersListIcon } from '@europrocurement/l2d-icons';
import PublisherDetail from './views/detail/Publisher/PublisherDetail';
import PublishersListing from './views/listing/PublishersListing';
import PublisherRoot from './views/PublisherRoot';
import { PUBLISHERS_LIST, PUBLISHERS_REMINDER_LIST, publishersBasePath } from './constants/paths';
import PublishersRemindersListing from './views/listing/PublishersRemindersListing';
import PublisherReminderDetails from './views/detail/PublisherReminder/PublisherReminderDetails';

export const PublisherRouter = {
    path: publishersBasePath,
    element: <PublisherRoot />,
    children: [
        {
            path: 'liste',
            children: [
                {
                    path: '',
                    index: true,
                    element: <PublishersListing />,
                },
                {
                    path: ':idPublisher',
                    element: <PublisherDetail />,
                },
            ],
        },
        {
            path: 'rappels',
            children: [
                {
                    path: '',
                    element: <PublishersRemindersListing />,
                },
                {
                    path: ':idPublisherReminder',
                    element: <PublisherReminderDetails />,
                },
            ],
        },
    ],
};

export const PublisherMenuEntries: MenuEntry[] = [
    {
        title: `${publisherIcon.displayName}s`,
        icon: publisherIcon,
        role: 'realm:interne',
        children: [
            {
                title: 'Liste des fournisseurs',
                icon: publishersListIcon,
                href: PUBLISHERS_LIST,
                role: 'realm:interne',
            },
            {
                title: 'Rappels',
                icon: 'reply-clock',
                href: PUBLISHERS_REMINDER_LIST,
                role: 'realm:interne',
            },
        ],
    },
];
